import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { CreateNoteRequest } from '../../interfaces/createNoterRequest';
import { GetNoteListResponse } from '../../interfaces/getNoteListResponse';
import { NoteDTO } from '../../interfaces/noteDTO';

@Injectable({ providedIn: 'root' })
export class NoteHttpService {

  constructor(
    protected httpClient: HttpClient,
  ) { }

  public getQuoteNotes(quoteId: number) {
    const httpCall = this.httpClient.get<GetNoteListResponse>(
      `${environment.api}/notes/quote/${quoteId}`,
    );

    return httpCall;
  }

  public createQuoteNote(quoteId: number, request: CreateNoteRequest) {
    const httpCall = this.httpClient.post<NoteDTO>(
      `${environment.api}/notes/quote/${quoteId}`,
      request,
    );

    return httpCall;
  }
}
